// src/components/pcr/sections/SceneSizeUp.tsx
import React from 'react';
import { useForm } from '../../../contexts/FormContext';
import SectionHeading from '../common/SectionHeading';
import TextareaField from '../common/TextareaField';

const SceneSizeUp: React.FC = () => {
  const { formData, updateFormField } = useForm();
  const { sceneSizeUp } = formData;

  const handleChange = (field: string, value: string) => {
    updateFormField('sceneSizeUp', field, value);
  };

  return (
    <div className="bg-gradient-to-br from-sky-50 to-white p-4 rounded-lg mb-6 shadow-md">
      <SectionHeading title="Scene Size-Up" />
      
      <div className="space-y-3">
        <div className="space-y-4">
          <TextareaField
            id="sceneSize-bsi"
            label="BSI"
            value={sceneSizeUp.BSI}
            onChange={(e) => handleChange('BSI', e.target.value)}
          />
          
          <TextareaField
            id="sceneSize-nature-of-illness"
            label="Nature of Illness"
            value={sceneSizeUp.natureOfIllness}
            onChange={(e) => handleChange('natureOfIllness', e.target.value)}
          />
          
          <TextareaField
            id="sceneSize-additional-resources"
            label="Additional Resources"
            value={sceneSizeUp.additionalResources}
            onChange={(e) => handleChange('additionalResources', e.target.value)}
          />
          
          <TextareaField
            id="sceneSize-spinal-precautions"
            label="Spinal Precautions"
            value={sceneSizeUp.spinalPrecautions}
            onChange={(e) => handleChange('spinalPrecautions', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default SceneSizeUp;